import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetApiRequest } from '../../services/api';

export const fetchAllContent = createAsyncThunk(
  'content/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { page = 1, limit = 10, filters = {} } = params;

      const response = await GetApiRequest("content", {
        page,
        limit,
        experienceId: filters.experienceId || undefined,
        type: filters.type || undefined,
      });

      const data = response?.data || {};
      const pagination = data.pagination || { page: 1, limit: 10, total: 0, pages: 1 };

      return {
        content: data.data || [],
        pagination: {
          pages: pagination.pages || 1,
          page: pagination.page || 1,
          total: pagination.total || 0
        }
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to load content');
    }
  }
);

const initialState = {
  content: [],
  loading: false,
  error: null,
  pagination: {
    pages: 1,
    page: 1,
    total: 0
  },
  currentPage: 1,
  limit: 10,
  filters: {
    experienceId: "",
    type: ""
  },
  hasLoaded: false,
  lastFetchedPage: null,
  lastFetchedLimit: null,
  lastFetchedFilters: null
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.currentPage = 1;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllContent.fulfilled, (state, action) => {
        state.loading = false;
        state.content = action.payload.content;
        state.pagination = action.payload.pagination;
        state.hasLoaded = true;
        state.lastFetchedPage = action?.meta?.arg?.page ?? state.pagination.page;
        state.lastFetchedLimit = action?.meta?.arg?.limit ?? state.limit;
        state.lastFetchedFilters = action?.meta?.arg?.filters ?? state.filters;
      })
      .addCase(fetchAllContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setCurrentPage, setFilters, clearError } = contentSlice.actions;
export default contentSlice.reducer;
